<template>
  <div class="survey-detail-info bg-white" v-loading="loading">
    <div class="container_left">
      <template v-if="hidDingzhiSurveyIdByYD">
      <div class="container_left1 mb-6" v-if="showAudio || showVideo || showGBImage">
        <h3 class="font-bold text-medium-x mb-3">录音录像</h3>
        <!--  -->
        <el-alert
          :type="detail.duringCallNum === amountIssue ? 'info' : 'warning'"
          show-icon
          :closable="false"
          v-if="detail.channel == 7"
        >
          <template slot="title">
            <span class="text-theme-black-850 text-medium font-normal">
              音频总时长:{{ totalAudioTime }}s
            </span>
            <span class="text-theme-black-850 text-medium font-normal ml-2.5"
              >通话内答题:
              <span
                :style="{
                  color: detail.duringCallNum < amountIssue ? 'rgb(213,10,37)' : 'rgb(37,147,252)'
                }"
                >{{ detail.duringCallNum }}</span
              >
              /{{ amountIssue }}
            </span>
            <span
              class="text-theme-black-850 text-medium font-normal"
              v-if="detail.duringCallNum < amountIssue"
            >
              （可能存在挂断后编辑答卷的情况）
            </span>
          </template>
        </el-alert>
        <!--  -->
        <div class="mt-2 text-medium leading-22 ml-6 mr-7 flex" v-if="showAudio">
          <span class="opacity-45 mr-3 whitespace-nowrap">答题录音</span>
          <div class="flex-1 overflow-hidden" v-if="audioFilesAll.length > 0">
            <el-dropdown
              v-for="(audio, index) of audioFilesAll"
              :key="audio.key"
              :class="['inline-block', index === audioFilesAll.length - 1 ? 'max-w-1/5' : 'w-1/5']"
              @command="commandMediaFileHandle(audio, 'audio', $event)"
            >
              <span
                class="text-theme px-1 box-border inline-block cursor-pointer"
              >{{audio.fileName}}</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="play">
                  <span class="text-medium text-theme-black-850">
                    <i class="el-icon-video-play mr-2"></i>播放
                  </span>
                </el-dropdown-item>
                <el-dropdown-item v-if="!hidAccount.includes(userInfo.phone)" command="download">
                  <span class="text-medium text-theme-black-850">
                    <i class="el-icon-download mr-2"></i>下载
                  </span>
                </el-dropdown-item>
                <el-dropdown-item v-if="showAudioToTextSurveyIds.includes(getSurveyId)" command="toText">
                  <span class="text-medium text-theme-black-850">
                    <i class="el-icon-refresh mr-2"></i>录音转文字
                  </span>
                </el-dropdown-item>
                <!-- <el-dropdown-item command="delete" v-if="!readonly">
                  <span class="text-medium text-theme-black-850">
                    <i class="el-icon-delete mr-2"></i>删除
                  </span>
                </el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
            <span class="w-1/5 text-theme px-1 box-border inline-block" v-if="!readonly">
              <i
                class="el-icon-plus text-medium-x text-theme cursor-pointer select-none"
                @click="addAudioHandle"
              ></i>
            </span>
          </div>
          <div class="flex-1 overflow-hidden mr-7 text-theme-black-850" v-else>
            <span v-if="readonly">暂无录音</span>
            <span class="text-theme px-1 box-border inline-block" v-else>
              <el-button type="text" size="small" @click="addAudioHandle">新增</el-button>
            </span>
          </div>
        </div>
        <template v-if="showVideo">
        <div class="mt-2 text-medium leading-22 ml-6 mr-7 flex" v-if="readonly">
          <span class="opacity-45 mr-3 whitespace-nowrap">答题录像</span>
          <div class="flex-1 overflow-hidden" v-if="videoFilesAll.length > 0">
            <span
              class="text-theme px-1 box-border inline-block cursor-pointer"
              v-for="(video, index) of videoFilesAll"
              :key="video.key"
              :class="index === videoFilesAll.length - 1 ? 'max-w-1/5' : 'w-1/5'"
              @click="commandMediaFileHandle(video, 'video', 'play')"
            >{{video.fileName}}</span>
          </div>
          <div class="flex-1 overflow-hidden mr-7 text-theme-black-850" v-else>暂无录像</div>
        </div>
        <div class="mt-2 text-medium leading-22 ml-6 mr-7 flex" v-else>
          <span class="opacity-45 mr-3 whitespace-nowrap">答题录像</span>
          <div class="flex-1 overflow-hidden" v-if="videoFilesAll.length > 0">
            <el-dropdown
              v-for="(video, index) of videoFilesAll"
              :key="video.key"
              :class="['inline-block', index === videoFilesAll.length - 1 ? 'max-w-1/5' : 'w-1/5']"
              @command="commandMediaFileHandle(video, 'video', $event)"
            >
              <span
                class="text-theme px-1 box-border inline-block cursor-pointer"
              >{{video.fileName}}</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="play">
                  <span class="text-medium text-theme-black-850">
                    <i class="el-icon-video-play mr-2"></i>播放
                  </span>
                </el-dropdown-item>
                <!-- <el-dropdown-item command="delete">
                  <span class="text-medium text-theme-black-850">
                    <i class="el-icon-delete mr-2"></i>删除
                  </span>
                </el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
            <span class="w-1/5 text-theme px-1 box-border inline-block">
              <i
                class="el-icon-plus text-medium-x text-theme cursor-pointer select-none"
                @click="addVideoHandle"
              ></i>
            </span>
          </div>
          <div class="flex-1 overflow-hidden mr-7 text-theme-black-850" v-else>
            <span v-if="readonly">暂无录像</span>
            <span class="text-theme px-1 box-border inline-block" v-else>
              <el-button type="text" size="small" @click="addVideoHandle">新增</el-button>
            </span>
          </div>
        </div>
        </template>
        <div class="mt-2 text-medium ml-6" v-if="showGBImage">
          <div class="flex items-center justify-between mr-7">
            <span class="opacity-45 leading-22">全局图片</span>
            <el-button size="small" type="text" @click="addImageHandle" v-if="!readonly">新增</el-button>
          </div>
          <div class="mt-2" style="width: 375px">
            <ul class="flex flex-wrap ul" v-if="gbImageFilesAll.length > 0">
              <li
                v-for="(item, index) of gbImageFilesAll"
                :key="item.key"
                class="relative hover_show"
              >
                <!-- <i
                  class="absolute top-1 right-1 z-10 el-icon-error text-medium-x text-icon-default cursor-pointer"
                  @click.stop="removeFileHandle(item, 'image')"
                  v-if="!readonly"
                ></i> -->
                <img
                  :src="item.url"
                  v-if="item.url"
                  class="w-full h-full object-cover"
                  @click="showPreviewHandle(index)"
                />
              </li>
            </ul>
            <div class="w-full text-center text-medium text-theme-black-850 leading-22" v-else>
              暂无图片
            </div>
          </div>
          <div class="line mt-6 mr-7"></div>
        </div>
      </div>
      </template>
      <div class="container_left1 mb-6">
        <h3 class="font-bold text-medium-x mb-3">基本信息</h3>
        <div
          v-for="field in infoFieldsTop"
          :key="field.key"
          class="mt-2 text-medium leading-22 ml-6 overflow-hidden flex"
        >
          <div class="mr-4 container_left1_span text-right"><span class="opacity-45 float-right">{{ field.label }}</span></div>
          <div class="flex-1" :class="field.valueClass"><span>{{ field.value }}</span></div>
        </div>
        <div class="mt-2 text-medium leading-22 ml-6 overflow-hidden flex">
          <div class="mr-4 container_left1_span text-right"><span class="opacity-45 float-right">答题地址</span></div>
          <div class="flex-1" style="width: 288px">
            <span>{{detail.answerAddress}}</span>
          </div>
        </div>
        <div v-if="!detail.answerAddress.includes('—')" style="height: 200px;" class="ml-6 mr-7 mt-2 bg-d8">
          <template v-if="isMap">
            <GDMap
              v-if="showGDMap"
              style="height: 100%"
              :ln="detail.surveyLon"
              :la="detail.surveyLat"
              :addr="detail.answerAddress"
            />
            <bd-map
              v-else
              style="height: 100%"
              :ln="detail.surveyLon"
              :la="detail.surveyLat"
              :addr="detail.answerAddress"
            />
          </template>

        </div>
        <div
          v-for="field in infoFieldsBottom"
          :key="field.key"
          class="mt-2 text-medium leading-22 ml-6 overflow-hidden flex"
        >
          <div class="mr-4 container_left1_span text-right"><span class="opacity-45 float-right">{{ field.label }}</span></div>
          <div class="flex-1" :class="field.valueClass"><span>{{ field.value }}</span></div>
        </div>
        <div class="line mt-6 ml-6 mr-7"></div>
      </div>

      <div
        class="container_left1 mb-6"
        v-if="detail.channel === 7 || isQSSample"
      >
        <h3 class="font-bold text-medium-x mb-3">样本信息</h3>
        <template v-if="isQSSample">
          <template v-if="!detail.samplePosition.length">
            <div class="mt-2 text-medium leading-22 ml-6">
              <span class="opacity-45 mr-4 w-11 text-right inline-block">姓名</span>
              <span>{{detail.sampleName}}</span>
            </div>
            <div class="mt-2 text-medium leading-22 ml-6">
              <span class="opacity-45 mr-4 w-11 text-right inline-block">手机号</span>
              <span>{{detail.samplePhone}}</span>
            </div>
          </template>
          <div v-for="item in detail.samplePosition" :key="item.questionId" class="mt-2 text-medium leading-22 ml-6">
            <span class="opacity-45 mr-4 text-right inline-block">{{item.title}}:</span>
            <span>{{item.content}}</span>
          </div>
        </template>
        <div class="line mt-6 ml-6 mr-7"></div>
      </div>

      <div
        class="container_left1 mb-6"
        v-if="![2, 9].includes(+detail.channel) && (isInterviewer || +redPacketsAmount > 0)"
      >
        <h3 class="font-bold text-medium-x mb-3">答题奖励</h3>
        <div class="mt-2 ml-6 mr-7 flex items-center justify-between">
          <div class="text-medium leading-22">
            <span class="opacity-45 mr-4">红包金额</span>
            <span>{{redPacketsAmount}}元</span>
          </div>
          <div class="text-danger text-medium leading-22">
            审核通过后发放{{redPacketSendText}}
          </div>
        </div>
        <div class="line mt-6 ml-6 mr-7"></div>
      </div>

      <template v-if="!isHiddenShow251024">
      <detail-task-flow v-if="!baseInfoConfig.hiddenTaskFlow" :currentId="answerId"/>

      <div v-if="!baseInfoConfig.hiddenUpdateRecord" class="container_left1 mb-6">
        <h3 class="font-bold text-medium-x mb-3">修改记录</h3>
        <div class="mt-2 text-medium leading-22 ml-6">
          <edit-record class="inline-block" :answerId="answerId"></edit-record>
        </div>
      </div>
      </template>
    </div>
    <move-video key="videoPlayer" v-if="isVideoPlay" :src="videoUrl" @close="videoUrl = ''"/>
    <image-viewer
      v-if="isViewer"
      :initial-index="currentIndex"
      :on-close="closeViewerHandle"
      :url-list="viewerList"
      :z-index="5000"
    />
    <add-media-dialog
      :visible.sync="showAddMedia"
      :add-type="addMediaType"
      @confirm="confirmAddMedia"
      @close="closeAddMedia"
    />
    <AudioToText :show.sync="audioToTextShow" :toTextItem="toTextItem"/>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import { isURL } from '@/assets/js/validate'
import { detail, getAnswerAddressInfo, getPasswordInfo } from '@/api/wenjuan/answerList'
import ImageViewer from 'dygc-ui/packages/image/src/image-viewer'
import { channel_list_options, typeConfig } from '@/components/survey-detail/config/index'
import DetailTaskFlow from '@/components/survey-detail/DetailTaskFlow'
import EditRecord from '@/components/survey-detail/EditRecord'
import AddMediaDialog from './components/AddMediaDialog'
import MoveVideo from './components/MoveVideo'
import GDMap from './GDMap.vue'
import bdMap from './bdMap.vue'
import { qcTypeMap } from './config';
import GlobalConfig from '@/global/config'
import { querySampleServiceByUser } from "@/api/wenjuan/sampleService"
import { mapGetters } from 'vuex'
import { hidAccount, showAudioToTextSurveyIds } from '@/assets/js/customVariables.js'
import AudioToText from './AudioToText'
import pageView from '@/mixins/pageView'
export default {
  name: 'SurveyDetailInfo',
  mixins:[pageView],
  components: {
    GDMap,
    bdMap,
    ImageViewer,
    DetailTaskFlow,
    EditRecord,
    MoveVideo,
    AddMediaDialog,
    AudioToText
  },
  props: {
    answerId: {
      type: [String, Number],
      default: ''
    },
    // 是否是只读模式（只能查看）
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // 加载数据loading
      loading: false,
      // 所有的详情数据
      detail: {
        surveyTitle: '',
        serialNumber: '',
        surveyRegion: '',
        submitTime: '',
        surveyDuration: '',
        surveyFinishTime: '',
        surveyStartTime: '',
        interviewerName: '',
        interviewerTelephone: '',
        supervisorName: '',
        reviewTime: '',
        accountUserId: '',
        accountUsername: '',
        relatedSampleId: '',
        interviewerId: null,
        sampleName: '',
        auditId: '',
        auditName: '',
        auditTime: '',
        samplePhone: '',
        sampleResidence: '',
        reason: '',
        taskName: '',
        answerChannel: '',
        channel: '',
        status: '',
        surveyLon: '',
        surveyLat: '',
        answerAddress: '',
        ipAddress: '',
        password: '',
        property: '',
        calleeName: '',
        callee: '',
        qcType: '',
        duringCallNum: 0,
        awardYuanAmount: null,
        shareAwardYuanAmount: null,
        awardSendSuccess: false,
        coordType: null,
        samplePosition: []
      },
      // 所有音频总长度
      totalAudioTime: 0,
      // 全局图片
      gbImageFiles: [],
      // 音频
      audioFiles: [],
      // 视频
      videoFiles: [],
      // 上传的图片
      uploadGBImageFiles: [],
      // 上传的音频
      uploadAudioFiles: [],
      // 上传的视频
      uploadVideoFiles: [],
      // 对外展示的数据
      audioFilesArr: [],
      imageFilesArr: [],
      videoFilesArr: [],
      // 是否显示预览
      isViewer: false,
      // 当前预览的下标
      currentIndex: 0,
      // 新增弹窗的类型
      addMediaType: '',
      // 新增弹窗显隐
      showAddMedia: false,
      // 是否播放录像
      videoUrl: '',
      hidAccount,
      showAudioToTextSurveyIds,
      audioToTextShow: false,
      toTextItem: {}
    }
  },
  watch: {
    answerId(id) {
      if (id) {
        this.uploadGBImageFiles.splice(0);
        this.uploadAudioFiles.splice(0);
        this.uploadVideoFiles.splice(0);
        this.getDetail();
      }
    },
    gbImageFilesAll: {
      handler(list) {
        this.imageFilesArr = (list || []).map(m => m.originUrl);
      },
      deep: true,
    },
    audioFilesAll: {
      handler(list) {
        this.audioFilesArr = (list || []).map(m => m.originUrl);
      },
      deep: true,
    },
    videoFilesAll: {
      handler(list) {
        this.videoFilesArr = (list || []).map(m => m.originUrl);
      },
      deep: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 231025定制修改
    isHiddenShow () {
      return !['VozgS6lE', 'ykXuIvSs', '8kC4VPaC', 'muVl4qit', 'LqL0g5sk', 'JXqqCR5H', '6mX3u8qQ', 'oDsNkZ2v', 'GuJEzYlQ', 'XgLFnK8v', 'J4DyNMlq', 'A8mZBb4g', '7X6WWy1B', 'KYK3w5L7', '24SBTKpQ', 'EW3ObZuY'].includes(this.$route.params.id)
    },
    // 251014定制修改
    isHiddenShow251024 () {
      return ["f1jdehuT","L4lGWYc2","jTomBpul","VPOAZQGI","VstPRoby","LbbchB8A","AIUJBRZR","jvRH08Jo","pCF6fATL","l0ZJLX53","6uEldbNV","jTomBpul"].includes(this.$route.params.id)
    },
    isHideInterviewrInfo(){
      return ["jTomBpul"].includes(this.$route.params.id)
    },
    // 有样本的用 sampleName 和 samplePhone
    // 没有的时候用 accountUserId，但是不用 accountUserName
    channelList() {
      return channel_list_options
    },
    answerSampleShow() {
      if(this.detail.sampleName || this.detail.samplePhone) {
        return this.detail.samplePhone + '-' + this.detail.sampleName
      }
      return this.detail.accountUserId // ? this.detail.accountUserId + '-' + this.detail.accountUsername : '—'
    },
    answerSampleIsShow() {
      // 链接&二维码 、 样本库推送
      return this.detail.channel === 0 || this.detail.channel === 10
    },
    answerStatus() {
      return typeConfig[this.detail.status]?.label ?? '—';
    },
    backChannel() {
      return channel_list_options[this.detail.channel] ?? '—';
    },
    viewerList() {
      return this.gbImageFiles.map(m => m.url);
    },
    gbImageFilesAll() {
      return this.gbImageFiles.concat(this.uploadGBImageFiles);
    },
    audioFilesAll() {
      return this.audioFiles.concat(this.uploadAudioFiles)
    },
    videoFilesAll() {
      return this.videoFiles.concat(this.uploadVideoFiles);
    },
    isVideoPlay() {
      return !!this.videoUrl;
    },
    redPacketsAmount() {
      const { awardYuanAmount, shareAwardYuanAmount } = this.detail;
      if (awardYuanAmount === null && shareAwardYuanAmount === null) return '0.00';
      return +(awardYuanAmount || shareAwardYuanAmount).toFixed(2);
    },
    isQSSample() {
      const { relatedSampleId, channel } = this.detail;
      return relatedSampleId && channel !== 7;
    },
    qcTypeText() {
      return qcTypeMap[this.detail.qcType] ?? '—';
    },
    amountIssue() {
      return this.$store.getters.questionList.length;
    },
    redPacketSendText() {
      return this.detail.awardSendSuccess ? '(已发放)' : '(未发放)';
    },
    isInterviewer() {
      return this.detail.interviewerId !== null;
    },
    showAudio() {
      if (!this.readonly) return true;
      return this.audioFilesAll.length > 0;
    },
    showVideo() {
      if (!this.readonly) return true;
      return this.videoFilesAll.length > 0;
    },
    showGBImage() {
      if (!this.readonly) return true;
      return this.gbImageFilesAll.length > 0;
    },
    isMap() {
      const { surveyLon, surveyLat, answerAddress } = this.detail;
      const eqList = [surveyLon, surveyLat, answerAddress];
      const isNil = eqList.some(s => ['', undefined, null].includes(s));
      return !isNil && !eqList.includes('—');
    },
    showGDMap() {
      return this.detail.channel === 0 || this.detail.coordType === 1
    },
    getSurveyId() {
      return GlobalConfig.getSurveyId()
    },
    hidSurveyId() {
      return GlobalConfig.getHideSurveyIds()
    },
    // 定制修改 2025-9-12 固定问卷隐藏多媒体
    hidDingzhiSurveyIdByYD() {
      return !['pCF6fATL', "f1jdehuT","L4lGWYc2","jTomBpul","VPOAZQGI","VstPRoby","LbbchB8A","AIUJBRZR","jvRH08Jo","l0ZJLX53", '6uEldbNV', '7Yg4F7Y9', 'S8vfQR1M', 'Wi4xaFd4', 'dYROFEku', 'K3waJIOu', '6B782zmn','jTomBpul'].includes(GlobalConfig.getSurveyId())
    },
    // 基本信息 - 地图上方字段
    infoFieldsTop() {
      const fields = []
      const { detail } = this
      // 员工/用户名（channel 17/18）
      if (detail.channel === 17 || detail.channel === 18) {
        fields.push({ key: 'accountUsername', label: detail.channel === 17 ? '员工(手机号)' : '用户名', value: detail.accountUsername })
      }
      // 用户ID（非面访，非251024定制隐藏）
      if (!this.isHiddenShow251024 && detail.channel !== 2) {
        fields.push({ key: 'userId', label: '用户ID', value: detail.accountUserId || detail.accountUserOpenId || detail.accountUserFingerprint })
      }
      fields.push({ key: 'answerId', label: '答卷ID', value: this.answerId || '—' })
      fields.push({ key: 'surveyTitle', label: '答卷名称', value: detail.surveyTitle, valueClass: 'break-all box-border pr-2' })
      if (detail.serialNumber) {
        fields.push({ key: 'serialNumber', label: '流水编号', value: detail.serialNumber })
      }
      if (!this.isHiddenShow251024) {
        if (this.isHiddenShow) {
          fields.push({ key: 'backChannel', label: '回收渠道', value: this.backChannel })
          fields.push({ key: 'answerChannel', label: '子渠道', value: detail.taskName || detail.answerChannel })
        }
        fields.push({ key: 'surveyStartTime', label: '开始答题', value: detail.surveyStartTime })
        if (this.isHiddenShow) {
          fields.push({ key: 'surveyFinishTime', label: '完成答题', value: detail.surveyFinishTime })
        }
        fields.push({ key: 'surveyDuration', label: '答题时长', value: `${detail.surveyDuration}秒` })
      }
      // 调查员信息（面访/电话访问）
      if ((this.isInterviewer || detail.accountUserId) && (detail.channel == 2 || detail.channel == 7)) {
        if (!this.isHideInterviewrInfo) {
          fields.push({ key: 'interviewer', label: '调查员', value: `${detail.interviewerName}-${detail.interviewerTelephone}` })
          fields.push({ key: 'uploadTime', label: '上传答卷', value: detail.submitTime })
        }
      }
      if (this.isHiddenShow) {
        fields.push({ key: 'submitTime', label: '提交时间', value: detail.submitTime })
      }
      fields.push({ key: 'answerStatus', label: '答卷状态', value: this.answerStatus })
      if (!this.isHiddenShow251024) {
        fields.push({ key: 'surveyRegion', label: '答题位置', value: detail.surveyRegion })
      }
      const hiddenFields = this.currentConfig.baseInfo?.hiddenFields || []
      return fields.filter(item=>{
       return !hiddenFields.includes(item.key)
      })
    },
    // 基本信息 - 地图下方字段
    infoFieldsBottom() {
      const fields = []
      const { detail } = this
      fields.push({ key: 'lonlat', label: '经纬度', value: `${detail.surveyLon}, ${detail.surveyLat}` })
      // IP地址
      if (!this.isHiddenShow251024 && this.isHiddenShow && !this.hidSurveyId.includes(this.getSurveyId)) {
        fields.push({ key: 'ipAddress', label: 'IP地址', value: detail.ipAddress })
      }
      // 电话访问 channel === 7
      if (detail.channel === 7) {
        if (detail.calleeName) {
          fields.push({ key: 'calleeName', label: '被叫姓名', value: detail.calleeName })
        }
        if (detail.callee) {
          fields.push({ key: 'callee', label: '相关手机号', value: detail.callee })
        }
      }
      // 审核信息 channel === 1
      if (detail.channel === 1) {
        fields.push({ key: 'supervisorName', label: '审核督导', value: detail.supervisorName })
        fields.push({ key: 'reviewTime', label: '审核时间', value: detail.reviewTime })
      }
      if (!this.isHiddenShow251024) {
        if (this.answerSampleIsShow) {
          fields.push({ key: 'answerSample', label: '答题样本', value: this.answerSampleShow })
        }
        fields.push({ key: 'qcType', label: '质控方式', value: this.qcTypeText })
      }
      const hiddenFields = this.currentConfig.baseInfo?.hiddenFields || []
      return fields.filter(item=>{
       return !hiddenFields.includes(item.key)
      })
    },
    baseInfoConfig(){
      return this.currentConfig.baseInfo || {}
    }
  },
  mounted() {
    this.getSampleServiceData()
    this.getDetail();
    this.setInit = this.initTotalAudioDuration();
  },
  methods: {
    // 获取样本服务数据
    async getSampleServiceData() {
      await querySampleServiceByUser(GlobalConfig.getSurveyId()).then(res => {
        if(res.data.code !== 0 || res.data.data.length === 0) return
        res.data.data.forEach((item, index) => {
          this.channelList[item.id] = `样本服务-第 ${index + 1} 次样本服务`
        })
      }).catch((err) => {console.log(err)})
    },
    setDetail(source) {
      this.detail.surveyTitle = source.surveyTitle ?? '—';
      this.detail.serialNumber = source.serialNumber ?? '';
      this.detail.surveyRegion = source.surveyRegion ?? '—';
      this.detail.submitTime = source.submitTime ?? '—';
      this.detail.surveyDuration = source.surveyDuration ?? '—';
      this.detail.surveyFinishTime = source.surveyFinishTime ?? '—';
      this.detail.surveyStartTime = source.surveyStartTime ?? '—';
      this.detail.interviewerName = source.interviewerName ?? '—';
      this.detail.interviewerTelephone = source.interviewerTelephone ?? '—';
      this.detail.supervisorName = source.supervisorName ?? '—';
      this.detail.reviewTime = source.reviewTime ?? '—';
      this.detail.accountUserId = source.accountUserId ?? '';
      this.detail.accountUsername = source.accountUsername ?? '';
      this.detail.relatedSampleId = source.relatedSampleId ?? '';
      this.detail.interviewerId = source.interviewerId ?? null;
      this.detail.sampleName = source.sampleName ?? '';
      this.detail.auditId = source.auditId ?? '';
      this.detail.auditName = source.auditName ?? '';
      this.detail.auditTime = source.auditTime ?? '—';
      this.detail.samplePhone = source.samplePhone ?? '';
      this.detail.sampleResidence = source.sampleResidence ?? '—';
      this.detail.reason = source.status === 10 ? (source.rejectReason ?? '—') : (source.auditDescription ?? '—');
      this.detail.taskName = source.taskName ?? '';
      this.detail.answerChannel = source.answerChannel ?? '—';
      this.detail.channel = source.channel ?? '—';
      this.detail.status = source.status ?? '—';
      this.detail.surveyLon = source.surveyLon ?? '—';
      this.detail.surveyLat = source.surveyLat ?? '—';
      this.detail.answerAddress = source.answerAddress ?? '—';
      this.detail.ipAddress = source.ipAddress ?? '—';
      this.detail.password = source.answerPassword ?? source.password ?? '—';
      this.detail.property = source.answerPasswordProperty ?? source.property ?? '—';
      this.detail.calleeName = source.calleeName ?? '—';
      this.detail.callee = source.callee ?? '—';
      this.detail.qcType = source.qcType ?? '';
      this.detail.duringCallNum = source.duringCallNum ?? 0;
      this.detail.awardYuanAmount = source.awardYuanAmount ?? null;
      this.detail.shareAwardYuanAmount = source.shareAwardYuanAmount ?? null;
      this.detail.awardSendSuccess = source.awardSendSuccess ?? false;
      this.detail.accountUserFingerprint  = source.accountUserFingerprint ?? '';
      this.detail.accountUserOpenId  = source.accountUserOpenId ?? '';
      this.detail.coordType  = source.coordType;
      this.detail.samplePosition = source.samplePosition || []
    },
    getDetail() {
      this.loading = true;
      Promise.all([
        detail(this.answerId),
        getPasswordInfo({ answerId: this.answerId }),
        getAnswerAddressInfo(this.answerId)
      ]).then(([dtRes, psRes,addrRes]) => {
        const { password = '', property = '' } = psRes.data?.data || {};
        const source = { ...dtRes.data?.data, password, property };
        if (addrRes) {
          Object.assign(source,{
            coordType: addrRes.coordType,
            surveyLon: addrRes.longitude,
            surveyLat: addrRes.latitude,
            answerAddress: addrRes.address
          })
        }
        this.setDetail(source);
        this.gbImageFiles = (source.imageFiles || [])
          .map((url, index) => ({
            key: `image_${Date.now()}${index}`,
            url: this.getFullUrl(url),
            originUrl: url,
            fileName: `图片${index + 1}`,
          }));
        this.audioFiles = (source.audioFiles || [])
          .map((url, index) => {
            const fileName = `音频${index + 1}`;
            return {
              key: `audio_${Date.now()}${index}`,
              url: this.getFullUrl(url),
              originUrl: url,
              downloadUrl: this.getFullUrl(url, fileName),
              fileName,
            }
          });
        this.videoFiles = (source.videoFiles || [])
          .map((url, index) => ({
            key: `video_${Date.now()}${index}`,
            url: this.getFullUrl(url),
            originUrl: url,
            fileName: `视频${index + 1}`,
          }));
        this.setInit();
      }).catch(() => {
        this.$message.error('获取基本详情信息失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    initTotalAudioDuration() {
      const audio = new Audio();
      let index = 1;
      let total = 0;
      audio.onloadeddata = () => {
        total += audio.duration;
        if (index === this.audioFilesAll.length) {
          this.totalAudioTime = Math.ceil(total);
          total = 0;
					index = 1;
        } else {
          audio.src = this.audioFilesAll[index]?.url ?? '';
					audio.load();
					index++;
        }
      }
      return () => {
        if (this.audioFilesAll.length > 0) {
          audio.src = this.audioFilesAll[0]?.url ?? '';
          audio.load();
        }
      }
    },
    removeFileHandle(item, type) {
      this.$confirm(`确认删除吗`, '资源删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.removeFile(item, type)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    removeFile(item, type) {
      switch(type) {
        case 'audio': {
          const adIndex = this.audioFiles.findIndex(f => f.key === item.key);
          if (adIndex > -1) {
            this.audioFiles.splice(adIndex, 1);
            this.setInit();
            break;
          }
          const aduIndex = this.uploadAudioFiles.findIndex(f => f.key === item.key);
          if (aduIndex > -1) {
            this.uploadAudioFiles.splice(aduIndex, 1);
            this.setInit();
            break;
          }
          break;
        }
        case 'video': {
          const vdIndex = this.videoFiles.findIndex(f => f.key === item.key);
          if (vdIndex > -1) {
            this.videoFiles.splice(vdIndex, 1);
            break;
          }
          const vduIndex = this.uploadVideoFiles.findIndex(f => f.key === item.key);
          if (vduIndex > -1) {
            this.uploadVideoFiles.splice(vduIndex, 1);
            break;
          }
          break;
        }
        case 'image': {
          const gbIndex = this.gbImageFiles.findIndex(f => f.key === item.key);
          if (gbIndex > -1) {
            this.gbImageFiles.splice(gbIndex, 1);
            break;
          }
          const gbuIndex = this.uploadGBImageFiles.findIndex(f => f.key === item.key);
          if (gbuIndex > -1) {
            this.uploadGBImageFiles.splice(gbuIndex, 1);
            break;
          }
          break;
        }
      }
    },
    downloadFileHandle(item) {
      saveAs(item.downloadUrl, `${item.fileName || '资源'}.png`);
    },
    commandMediaFileHandle(item, type, command) {
      if (command === 'play') {
        if (type === 'audio') {
          this.$emit('audioPlay', item); // 从传url改成传item
        } else if (type === 'video') {
          this.videoUrl = item.url;
        }
      } else if (command === 'download') {
        this.downloadFileHandle(item);
      } else if (command === 'delete') {
        this.removeFileHandle(item, type);
      } else if(command === 'toText') {
        this.audioToTextShow = true
        this.toTextItem = item
      }
    },
    getFullUrl(url = '', downloadName = '') {
      const originURL = window.location.origin;
      if (url.includes('admin/sys-file')) {
        return `${originURL}${url}`;
      } else if (downloadName) {
        return `${originURL}/fill/api/v1/downloadWithName?fileName=${url}&downLoadName=${downloadName}`;
      } else if (isURL(url)) {
        return url;
      }
      return `${originURL}/fill/api/v1/download?fileName=${url.startsWith('/') ? url.slice(1) : url}`;
    },
    showPreviewHandle(index) {
      this.currentIndex = index;
      this.isViewer = true;
    },
    closeViewerHandle() {
      this.currentIndex = 0;
      this.isViewer = false;
    },
    addImageHandle() {
      this.showAddMedia = true;
      this.addMediaType = 'image';
    },
    addAudioHandle() {
      this.showAddMedia = true;
      this.addMediaType = 'audio';
    },
    addVideoHandle() {
      this.showAddMedia = true;
      this.addMediaType = 'video';
    },
    confirmAddMedia({ image, video, audio }) {
      switch(this.addMediaType) {
        case 'image': {
          let initIndex = this.gbImageFilesAll.length;
          for (const img of image) {
            this.uploadGBImageFiles.push({
              key: `image_${Date.now()}${initIndex + 1}`,
              url: this.getFullUrl(img.url),
              originUrl: img.url,
              fileName: `图片${initIndex + 1}`
            });
            initIndex++;
          }
          break;
        }
        case 'video': {
          let initIndex = this.videoFilesAll.length;
          for (const vd of video) {
            this.uploadVideoFiles.push({
              key: `video_${Date.now()}${initIndex + 1}`,
              url: this.getFullUrl(vd.url),
              originUrl: vd.url,
              fileName: `视频${initIndex + 1}`
            });
            initIndex++;
          }
          break;
        }
        case 'audio': {
          let initIndex = this.audioFilesAll.length;
          for (const ad of audio) {
            const fileName = `音频${initIndex + 1}`;
            this.uploadAudioFiles.push({
              key: `audio_${Date.now()}${initIndex + 1}`,
              url: this.getFullUrl(ad.url),
              originUrl: ad.url,
              fileName,
              downloadUrl: this.getFullUrl(ad.url, fileName)
            });
            initIndex++;
          }
          this.setInit();
          break;
        }
      }
      this.closeAddMedia();
    },
    closeAddMedia() {
      this.addMediaType = '';
      this.showAddMedia = false;
    }
  },
}
</script>
<style lang="scss" scoped>
.container_left {
  overflow-x: hidden;
  width: 412px;
  padding-top: 20.02px;

  .container_left1 {
    h3 {
      padding-left: 20px;
      height: 20.02px;
      border-left: 4px solid;
      font-family: PingFangSC-Medium;
      color: #000000;
      line-height: 19px;
      box-sizing: border-box;
      @apply border-theme;
    }
    .container_left1_span {
      width: 56px;
      min-height: 22px;
    }
    .ul {
      li {
        float: left;
        width: 116px;
        height: 79px;
        margin-right: 6px;
        margin-bottom: 6px;
        background: #d8d8d8;
      }
      overflow: hidden;
    }
    .line {
      height: 1px;
      background: #e7e9eb;
    }
  }

  .hover_show {
    &>i {
      display: none;
    }
    &:hover>i {
      display: inline-block;
    }
  }
  .max-w-1\/5 {
    max-width: 20%;
  }
}
</style>
